import { Component, OnDestroy, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../app/common/constants/global.constant';
import { RouterConstants } from '../../core/routing/constants/app-paths.constant';
import { ProfileService } from '../../core/routing/services/profile_api/profile.service';
import { Profile } from '../../modules/profile/interface/profile.i';
import { DeleteComponent } from './delete/delete.component';
import { LANGUAGE_MAPPINGS } from '../../common/constants/language-mappings.const';
import { InstallationPackageService } from '../../core/routing/services/installation-package/installation-package.service';
import { ProfileAPI } from '../../core/routing/services/profile_api/constants/profile.constant';
import { WebsocketService } from '../../core/routing/services/websocket/websocket.service';
import { Utils } from '../../common/utils/utils';
import { CommonService } from '../../common/services/common.service';
import { environment } from '../../../environments/environment';
import { DevicesConstants } from '../../core/routing/services/devices/constants/devices.constants';
import { GoogleAnalyticsService } from '../google-analytics/google-analytics.service';
import { CreateProfileService } from '../../core/routing/services/profile/create-profile.service';
import { OemConstants } from '../../core/routing/services/oem/constants/oem.constants';
import { AppGlobal } from '../../core/state/app-global';
import { User } from '../account/login/_models/user.model';
import { DateFormatPipe } from '../pipes/pipe-util/date-formate.pipe';
import { StoresConstant } from '../../../app/core/routing/services/stores_api/constants/stores.constant';
import { ActiveUserConstants } from '../../../app/core/routing/services/activeusers_api/constatnts/activeusers.constant';

@Component({
  selector: 'iposcen-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [DateFormatPipe]
})
export class ProfileComponent implements OnInit, OnDestroy {
  @Input() tabIndex = 0;
  @ViewChild('duplicateProfile') duplicateProfile: ElementRef;
  @ViewChild('confirmGenModal') confirmGenModal: ElementRef;
  @ViewChild('searchValue') animateThis: ElementRef;
  profileData: Profile[] = [];
  profileDataVal: Profile[] = [];
  duplicate = GlobalConstants.DUPLICATE;
  edit = GlobalConstants.EDIT;
  deleteTooltipLabel = GlobalConstants.DELETE;
  page: number;
  count: number;
  tableSize: number;
  message: number;
  showFrom: number;
  showTo: number;
  exisitingProfiles: string;
  profileName: string;
  fullPkgName: string;
  created: string;
  languages: string;
  noRecordFound: string;
  preview: string;
  download: string;
  generate: string;
  generating: string;
  showing: string;
  of: string;
  profilesHeading: string;
  createProfile: string;
  maxSize = 5;
  packageStatus: string;
  progressStatus: string;
  responseProfile: string;
  isDataLoading: boolean = true;
  queryParam: any;
  packagetype: string;
  isProfileDataEmpty: boolean;
  mainStreamWinText = GlobalConstants.MAIN_STREAM_HEADING;
  linuxIsoQueryParam = ProfileAPI.LINUX_ISO_QUERY_PARAM;
  linuxIposQueryParam = ProfileAPI.LINUX_IPOS_QUERY_PARAM;
  WindowsQueryParam = ProfileAPI.WINDOWS_QUERY_PARAM;
  WindowsUwpQueryParam = ProfileAPI.WINDOWS_10S_QUERY_PARAM;
  IposLite = GlobalConstants.IPOS_LITE;
  ispackageGenerationInprogress = false;
  downloadPopup: boolean;
  selectlinuxospackagePopup: boolean;
  generatepackageprogressPopup: boolean;
  isWindows10S: boolean;
  downloadUrl: string;
  fileExtension: string;
  profileId: string;
  currentProfileName: string;
  currentProfileId: string;
  //UAT-244
  uwpDefaultPackage = environment.uwpDefaultPackage;
  //UAT-244
  installationRememberText = GlobalConstants.INTSALLATION_MESSAGE;
  installationProfileText = GlobalConstants.WIN10S_MESSAGE;
  installationPoint3 = GlobalConstants.PACKAGE_POINT3;
  installationPoint4 = GlobalConstants.PACKAGE_POINT4;
  downloadPackageName = GlobalConstants.DOWNLOAD_PACKAGE_TITLE;
  generatePackageSelectTitle = GlobalConstants.GENERATE_PACKAGE_SELECT_LINUX_TITLE;
  generatePackageSelectLinuxiso = GlobalConstants.GENERATE_PACKAGE_LINUX_ISO;
  generatePackageSelectLinuxipos = GlobalConstants.GENERATE_PACKAGE_LINUX_IPOS;
  generatePackageProgressTitle = GlobalConstants.GENERATE_PACKAGE_PROGRESS_TITLE;
  generatePackageProgressContent = GlobalConstants.GENERATE_PACKAGE_PROGRESS_CONTENT;
  generatePackageProfileId: string;
  shareURLText = GlobalConstants.SHARE_URL_NAME;
  copyText = GlobalConstants.COPY_TEXT_NAME;
  userProfileId = GlobalConstants.USER_PROFILE_IDS;
  downloadClick = GlobalConstants.CLICK_DOWNLOAD;
  downloadIPOS: string;
  showRetailGif = false;
  updateLastUpdate = DevicesConstants.LAST_UPDATE;
  retailerID = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  generateResponse = sessionStorage.getItem(GlobalConstants.GENERATE_RESPONSE);
  profileSettingsForGA: any; //For GA
  customMainTileAdded = false; // For GA
  srtHeroTiles: any;  // For GA
  pkgLangForGA = '';   //For GA
  pkgTypeForGA: string; //For GA
  osForGA: string;  //for GA
  isGamingMessage: boolean;
  sortBy: string;
  sortType: string;
  gamingPackageMsgText = GlobalConstants.GAMING_PKG_USB_MSG;
  packageDwnldAgainMsg = GlobalConstants.CUSTOM_PROFILE_PKG_DWNLD_MSG;
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  profileDataPagination: Profile[];
  selectedValue: string = 'custom';
  filterType: string[] = ['custom', 'standard'];
  retailerId: string;
  userId: string;
  isOverTheAirUpdatesEnabled: boolean;
  paginationCount: number;
  private ngUnsubscribe = new Subject<boolean>();
  mainstreamText = GlobalConstants.MAIN_STREAM_HEADING;
  iposliteText = GlobalConstants.IPOS_LITE_PRC;
  viewDevice = GlobalConstants.VIEW_DEVICE;
  isAscendingSort = false;
  isLoading = false;
  timestamp: string;
  globConst = GlobalConstants;
  confirmModalTitle: string;
  confirmModalDesc: string;
  confirmModalCTA: string;
  selectedProfile: any;
  selProfileIndex: number;
  globalConst = GlobalConstants;
  updateIPOSDisplayMsg = GlobalConstants.UPDATE_IPOS_DISPLAY_MSG;
  updateIPOSLiteDisplayMsg = GlobalConstants.UPDATE_IPOS_LITE_DISPLAY_MSG;
  isTableSortApplied = false;
  isSwitched = false;
  searchData: string;
  searchPlaceHolderText = GlobalConstants.SEARCHPLACEHOLDER;
  profileSearchBy: string;
  profileDataSearch = false;
  showProfileSearchDetails = false;
  isProfileSearch = false;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  searchClose = false;
  loadFlag: string;
  searchTag: string;
  searchMainstreamResult = false;
  isIposLite: boolean = false;
  showIposLiteMsg: boolean = false;
  enableIposlite: boolean = false;
  currentProfileGameName : string;

  constructor(
    private profileService: ProfileService,
    private appGlobal: AppGlobal,
    private router: Router,
    private dateFormatePipe: DateFormatPipe,
    private modalService: NgbModal,
    private installationPackageService: InstallationPackageService,
    private webSocketConn: WebsocketService,
    private commonService: CommonService,
    private createProfileService: CreateProfileService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.isDataLoading = true;
    this.profilesHeading = GlobalConstants.PROFILES_HEADING;
    this.createProfile = GlobalConstants.CREAT_PROFILES;
    this.page = 1;
    this.count = 0;
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.showTo = Math.min(this.page * this.tableSize);
    this.sortBy = OemConstants.LAST_UPDATED_TIME;
    this.sortType = OemConstants.DESCENDING_ORDER;
    this.exisitingProfiles = this.tabIndex ? 'Profiles' : GlobalConstants.EXISTING_PROFILES;
    this.download = GlobalConstants.DOWNLOAD;
    this.generate = GlobalConstants.GENERATE;
    this.generating = GlobalConstants.GENERATING;
    this.preview = GlobalConstants.PREVIEW;
    this.noRecordFound = GlobalConstants.NO_RECORDS_FOUND;
    this.profileSearchBy = '';
    this.searchData = '';
    this.downloadIPOS = GlobalConstants.DOWNLOAD_LIBRARY_IPOS;
    this.userId = sessionStorage.getItem(GlobalConstants.USER_ID);
    this.retailerId = sessionStorage.getItem('retailerId');
    this.commonService.getProfileWebSocketData
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.isSwitched = data;
      });
    this.commonService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
        }
      });

    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          const retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId, this.retailerId);
          this.isOverTheAirUpdatesEnabled = retailerConfig?.enableUpdateIPOSOverTheAir ? retailerConfig?.enableUpdateIPOSOverTheAir : false;
          this.enableIposlite = retailerConfig?.isIposChinaEnabled ? retailerConfig?.isIposChinaEnabled : false;
        }
        if ((this.userRole === GlobalConstants.NON_CONNECTED_USER && localStorage.getItem('preferredLanguage') === 'zh-Hans') || this.enableIposlite) {
          this.isIposLite = true;
        }
      });
    //WebSocket Call -> To get profile response
    if (!this.router.url.includes(GlobalConstants.PROFILE_IPOS)) {
      if (!this.isSwitched) {
        this.webSocketConn.profileDashboardWebSocketURL
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllProfileResponse => {
            if (getAllProfileResponse['responseContext'] && getAllProfileResponse['paginationContext'] === undefined && getAllProfileResponse['profile'] === undefined && getAllProfileResponse['profileWSCall'] === undefined) {
              this.getAllProfilesByUserId(); // when first WS network call estabhilished
            } else if (getAllProfileResponse['profileWSCall'] && getAllProfileResponse['profileWSCall'] === true) {
              if (this.searchData && this.searchData?.length) {
                this.searchProfilesReport(this.searchData);
              } else {
                this.getAllProfilesByUserId(); // Manual API call to get the correct data
              }
            } else {
              this.getProfileApiResponse(getAllProfileResponse); // To consume WS Response as is
            }
          },
            err => {
              this.isDataLoading = false;
              Utils.handleError(err, this.constructor.name)
            }
          );
        this.webSocketConn.profileDashboardWebSocketURL.next({
          userId: this.userId
        });
      } else if (this.isSwitched) {
        this.getAllProfilesByUserId();
      }
    }
    else {
      this.getAllProfilesByUserId();
    }
    this.profileService.emitInstallationPackage.subscribe(info => {
      if (info) this.ispackageGenerationInprogress = info;
    });
    //IIT2-14840
    this.cmnService.profileSocketObser.subscribe(info => {
      location.reload();
    });
  }

  getProfileApiResponse(getAllProfileResponse) {
    if (getAllProfileResponse && getAllProfileResponse['paginationContext']) {
      //IIT2-14132
      if (getAllProfileResponse?.paginationContext?.totalPages && (getAllProfileResponse?.paginationContext?.currentPage > getAllProfileResponse?.paginationContext?.totalPages)) {
        this.onTableDataChange(getAllProfileResponse?.paginationContext?.totalPages);
      } else {
        if (getAllProfileResponse && getAllProfileResponse['profile']) {
          //when ws response comes for pkg updates(without API trigger)
          if (getAllProfileResponse['paginationContext'] == undefined) {
            this.page = 1;
            this.count = 0;
            this.tableSize = 10;
            this.showFrom = ((this.page - 1) * this.tableSize) + 1;
            this.showTo = Math.min(this.page * this.tableSize);
          } else {
            this.paginationCount = (this.selectedValue === 'custom') ? getAllProfileResponse['paginationContext']?.totalItems : getAllProfileResponse['standardPackage'].length;
            this.showFrom = ((this.page - 1) * this.tableSize) + 1;
            this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
          }
          this.mapResponseData(getAllProfileResponse);
        } else {
          this.profileData = [];
          this.isProfileDataEmpty = true;
          this.isDataLoading = false;
        }
      }
    }
  }
  //XHR Get call -> To fetch all Profiles by User ID
  getAllProfilesByUserId() {
    this.profileService.getAllProfilesByUser(this.retailerID, this.page, this.sortBy, this.sortType, this.tabIndex, this.selectedValue, this.filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((getAllProfileResponse) => {
        if (getAllProfileResponse.responseContext.success) {
          this.showProfileSearchDetails = true;
        }
        this.profileDataSearch = (getAllProfileResponse['profile'] === undefined && this.isProfileSearch) || false;
        if (this.isSwitched && this.userRole === 'regionalHQ') {
          this.getProfileApiResponse(getAllProfileResponse);
        } else if (this.userRole === 'regionalHQ' && this.tabIndex === 0 && this.isProfileSearch) {
          this.getProfileApiResponse(getAllProfileResponse);
        }
        //only if standard
        if (this.router.url.includes(GlobalConstants.PROFILE_IPOS)) {
          this.paginationCount = (this.selectedValue === 'custom') ? getAllProfileResponse?.paginationContext?.totalItems : (getAllProfileResponse['standardPackage'] ? getAllProfileResponse['standardPackage']?.length : 0);
          this.showFrom = ((this.page - 1) * this.tableSize) + 1;
          this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
          this.mapResponseData(getAllProfileResponse);
        }
        this.commonService.setProfileWebSocketData(false);
      },
        err => {
          this.isDataLoading = false;
          Utils.handleError(err, this.constructor.name)
        });
  }

  mapResponseData(response) {
    this.profileDataVal = [];
    const profilePack = (this.selectedValue === 'custom') ? (Array.isArray(response) ? response as Profile[] : response['profile'] as Profile[]) : response['standardPackage'];
    this.profileData = profilePack;
    this.isDataLoading = false;
    this.isProfileDataEmpty = (!this.profileData || this.profileData?.length === 0) || false;
    this.profileDataSearch = (this.profileData?.length === 0 && this.isProfileSearch) || false;
    if (!this.isProfileDataEmpty) {
      if (!this.isTableSortApplied) this.profileData.sort((profile1, profile2) => { return +new Date(profile2.updatedDate) - +new Date(profile1.updatedDate); });
      for (let i = 0; i < this.profileData?.length; i++) {
        let updatedTime = new Date(this.profileData[i].updatedDate);
        let timeDiff = Utils.getHourDifference(updatedTime);
        if (timeDiff >= 2 && this.profileData[i].packageStatus === GlobalConstants.PND_LWR) {
          this.profileData[i].packageStatus = GlobalConstants.DFT_LWR;
          //update API call 
          this.profileService.updateProfileProgressStatus(this.profileData[i].profileId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((getAllProfileResponse) => { },
              err => {
                Utils.handleError(err, this.constructor.name)
              });
        }
      }
      this.profileData.forEach(ele => {
        if (ele.progressStatus === GlobalConstants.PROGRESS_STATUS_INQUEUE) ele.packageGenerationProgress = 5;
        else if (ele.progressStatus === GlobalConstants.PROGRESS_STATUS_READ) ele.packageGenerationProgress = 25;
        else if (ele.progressStatus === GlobalConstants.PROGRESS_STATUS_ASSETDOWNLOADED) ele.packageGenerationProgress = 50;
        else if (ele.progressStatus === GlobalConstants.PROGRESS_STATUS_PACKAGECREATED) ele.packageGenerationProgress = 75;
        else if (ele.progressStatus === GlobalConstants.PROGRESS_STATUS_COMPLETED) {
          ele.pbStarted = false;
          ele.packageGenerationProgress = 100;
        }
        this.getStandPackFromProfileResponse(ele);
        if (ele.standardPack === 'iposlite' && this.isIposLite) {
          this.showIposLiteMsg = true;
        }
      });
      if (this.tabIndex) this.profileData = this.profileDataVal;
    } else {
      this.profileData = [];
    }
    if (this.selectedValue === 'standard' && this.isProfileSearch) {
      this.mainStreamWinText = this.mainstreamText.toUpperCase();
      this.searchMainstreamResult = this.mainStreamWinText.includes(this.searchData.toUpperCase());
      if (!this.searchMainstreamResult) {
        this.profileData = [];
        this.isProfileDataEmpty = true;
      }
    }
    this.isDataLoading = false;
    this.commonService.setRetailGifValue(false);
    this.commonService.setProfileWebSocketData(false);
  }

  getStandPackFromProfileResponse(item) {
    if ((this.tabIndex) && (((item.operatingSystem == 'WINDOWS') && (item.contentTypes == '"Standard"')) || (item.pkgOperatingSystem == 'windows') && (item.standardPack == 'standard'))) {
      item.contentTypes = 'Mainstream';
    }
    if ((this.tabIndex) && (item.standardPack === 'iposlite' && item.pkgOperatingSystem === 'iposlite')) {
      item.contentTypes = 'iposlite';
    }
    if (this.selectedValue === 'standard') {
      item.languageCode = this.getLanguageNames(item.languageCode);
    }
    this.profileDataVal.push(item);
  }

  checkOSType(osType) {
    const status = ['WINDOWS', 'Windows 10', 'WindowsUWP', 'IPOSLITE'].indexOf(osType) > -1
    return status;
  }

  getOSName(operatingSystem) {
    if (operatingSystem == undefined) return undefined;
    else {
      const osName = Utils.getOperatingSystemTypeFromServer(operatingSystem);
      const result = this.checkOS(osName);
      return result;
    }
  }

  getLanguageNames(langCodeList) {
    if (langCodeList == undefined) return undefined;
    else {
      let languageArray = [];
      (this.selectedValue === 'standard') ? languageArray.push(langCodeList) : languageArray = this.removeStringifiedArray(langCodeList);
      for (let i = 0; i < languageArray.length; i++) {
        if (languageArray[i] === GlobalConstants.CHINESE_TW) {
          languageArray[i] = GlobalConstants.CHINESE_HANT;
        } else if (languageArray[i] === GlobalConstants.CHINESE_CN) {
          languageArray[i] = GlobalConstants.CHINESE_HANS;
        }
      }
      const langNameList: any = [];
      LANGUAGE_MAPPINGS.forEach(data => {
        if (data.langCode === GlobalConstants.CHINESE_TW) {
          data.langCode = GlobalConstants.CHINESE_HANT;
        } else if (data.langCode === GlobalConstants.CHINESE_CN) {
          data.langCode = GlobalConstants.CHINESE_HANS;
        }
        const langCode = languageArray.find(item => item.toLowerCase() === data.langCode.toLowerCase());
        if (langCode) {
          langNameList.push(data.langInEng);
        }
      });
      const result = langNameList?.join(', ');
      return result;
    }
  }

  removeStringifiedArray(data) {
    const finalArr = [];
    if (data[0] === "") return finalArr;
    else {
      if (data[0].split(",").length == 1) {
        finalArr.push(JSON.parse(data[0]));
        return finalArr;
      } else {
        const stringifiedArr = data[0].split(",");
        for (let i = 0; i < stringifiedArr.length; i++) {
          finalArr.push(JSON.parse(stringifiedArr[i]));
        }
        return finalArr;
      }
    }
  }

  getAllGeneratedProfiles(profileId, index) {
    setTimeout(() => {
      this.profileData[index].packageGenerationProgress = 5;
      this.profileService.getAllGeneratedProfiles(profileId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(responsevalue => {
          this.getAllProfilesByUserId();
        },
          err => {
            this.isDataLoading = false;
            Utils.handleError(err, this.constructor.name)
          }
        );
    }, 5000);
  }

  getProgressbarBgColor(packageGenerationProgress) {
    return `radial-gradient(closest-side, white 79%, transparent 80% 100%),conic-gradient(#8BAE46 ${packageGenerationProgress * 3.6}deg, #E9E9E9 0)`;
  }

  onCloseSelectPackagePopup() {
    this.selectlinuxospackagePopup = false;
  }

  checkOS(data) {
    let operatingSystem;
    if (data === 'Linux/Devices with no operating systems') {
      operatingSystem = GlobalConstants.LINUX_NAME;
    } else if (data === 'UWP for Windows in S Mode') {
      operatingSystem = GlobalConstants.UWP_NAME;
    } else return data;
    return operatingSystem;
  }

  onGeneratePackage(profile, index?) {
    this.selectedProfile = profile;
    this.selProfileIndex = index;
    if (!profile?.latestProfilePushTime) this.choosePackage(this.selectedProfile, this.selProfileIndex);
    else {
      let latestPushedTime = this.dateFormatePipe.transform(profile?.latestProfilePushTime, 'changeToLocalTime');
      this.confirmModalTitle = GlobalConstants.PUSH_GEN_POPUP_TITLE;
      this.confirmModalDesc = latestPushedTime;
      this.confirmModalCTA = GlobalConstants.GENERATE;
      this.openModal(this.confirmGenModal);
    }
  }

  choosePackage(profile, index) {
    this.generatePackageProfileId = profile.profileId;
    if (profile?.operatingSystem !== GlobalConstants.LINUX_OS) {
      this.profileData[index].packageGenerationProgress = 0;
      this.profileData[index].pbStarted = true;
    }
    if (profile?.operatingSystem === GlobalConstants.LINUX_OS) {
      this.selectlinuxospackagePopup = true;
    } else if (profile?.operatingSystem === GlobalConstants.WINDOWS_OS) {
      this.onGenerateWindows(index);
    } else if (profile?.operatingSystem === GlobalConstants.WINDOWSUWP) {
      this.onGenerateWindowsUWP(index);
    } else if (profile?.operatingSystem === GlobalConstants.CHROME_TYPE) {
      this.onGenerateChrome(index);
    } else if (profile?.operatingSystem === 'IPOSLITE') {
      this.onGenerateIposLite(index);
    }
    // this.googleAnalyticsService.createNewProfileSuccess();  //for GA
  }

  onGenerateIposLite(index) {
    this.prepareQueryParamData(this.IposLite, this.IposLite);
    this.installationPackageService.generateInstalltionPackage(this.generatePackageProfileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.getAllGeneratedProfiles(this.generatePackageProfileId, index);
      },
        error => {
          Utils.handleError(error, this.constructor.name)
        });
  }

  onGenerateWindows(index) {
    this.prepareQueryParamData(this.WindowsQueryParam, GlobalConstants.WINDOWS);
    this.installationPackageService.generateInstalltionPackage(this.generatePackageProfileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.sendDataToGA(this.generatePackageProfileId);
        this.getAllGeneratedProfiles(this.generatePackageProfileId, index);
      },
        error => {
          Utils.handleError(error, this.constructor.name)
        });
  }

  // Function to generate package from profile dashboard. 
  onGenerateChrome(index) {
    this.prepareQueryParamData(ProfileAPI.CHROME_QUERY_PARAM, GlobalConstants.WINDOWS);
    this.installationPackageService.generateInstalltionPackage(this.generatePackageProfileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.sendDataToGA(this.generatePackageProfileId);
        this.getAllGeneratedProfiles(this.generatePackageProfileId, index);
      },
        error => {
          Utils.handleError(error, this.constructor.name)
        });
  }

  onGenerateWindowsUWP(index) {
    this.prepareQueryParamData(this.WindowsUwpQueryParam, GlobalConstants.WINDOWS);
    this.installationPackageService.generateInstalltionPackage(this.generatePackageProfileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.sendDataToGA(this.generatePackageProfileId);
        this.getAllGeneratedProfiles(this.generatePackageProfileId, index);
      },
        error => {
          Utils.handleError(error, this.constructor.name)
        });
  }

  onGenerateLinuxISO() {
    let profile = this.profileData.filter(id => id.profileId === this.generatePackageProfileId);
    profile[0].packageGenerationProgress = 0;
    profile[0].pbStarted = true;
    this.prepareQueryParamData(this.linuxIsoQueryParam, GlobalConstants.LINUX);
    this.installationPackageService.generateInstalltionPackage(this.generatePackageProfileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.sendDataToGA(this.generatePackageProfileId);
      },
        error => {
          Utils.handleError(error, this.constructor.name)
        });
    this.onGeneratePackageProgress();
  }

  onGenerateLinuxIPOS() {
    let profile = this.profileData.filter(id => id.profileId === this.generatePackageProfileId);
    profile[0].packageGenerationProgress = 0;
    profile[0].pbStarted = true;
    this.prepareQueryParamData(this.linuxIposQueryParam, GlobalConstants.LINUX);
    this.installationPackageService.generateInstalltionPackage(this.generatePackageProfileId, this.queryParam)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.sendDataToGA(this.generatePackageProfileId);
      },
        error => {
          Utils.handleError(error, this.constructor.name)
        });
    this.onGeneratePackageProgress();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  prepareQueryParamData(packagetype, operatingsystem) {
    const queryParam = [
      ProfileAPI.PACKAGE, operatingsystem, packagetype
    ];
    // if(this.userRole === GlobalConstants.REGIONALHQ){
    //   queryParam.push(this.retailerID);
    // }***Commented code for later release IIT2-14840
    this.queryParam = queryParam;
  }

  onGeneratePackageProgress() {
    this.selectlinuxospackagePopup = false;
    this.generatepackageprogressPopup = true;
  }

  onCloseGeneratePackageProgressPopup() {
    this.generatepackageprogressPopup = false;
    this.getAllProfilesByUserId();
  }

  onPreviewPackage(profile) {
    //gtm(google tag manager)
    window['dataLayer'].push({
      'preview_customized_ipos': true
    });
  }

  onDownloadPackage(profile) {
    this.profileSettingsForGA = profile?.settings;
    this.downloadPopup = true;
    const contentTypesArr = this.removeStringifiedArray(profile?.contentTypes);
    const isGamingIncluded = contentTypesArr.includes(GlobalConstants.GAMING);
    this.isGamingMessage = isGamingIncluded ? true : false;
    this.isWindows10S = GlobalConstants.WINDOWS_UWP === profile?.operatingSystem;
    //To get what after the last'/' from URL
    this.fullPkgName = decodeURIComponent(profile.pkgDownloadUrl.split(/[/ ]+/).pop());
    let checkExt = this.fullPkgName.split(/[. ]+/);
    const fileExt = checkExt[checkExt.length - 1];
    this.fileExtension = '.' + fileExt;
    if (this.fileExtension === '.0_amd64') {
      this.fileExtension = GlobalConstants.FILE_EXTENSION_DEB;
    }

    this.downloadUrl = profile.pkgDownloadUrl;
    this.profileName = profile.profileName;
    this.profileName = this.profileName.replace(/_/g, ' ');
    this.profileId = profile.profileId;
    this.osForGA = profile?.operatingSystem;
    this.pkgLangForGA = profile.languages[profile.languages.length - 1];
    if (fileExt === GlobalConstants.PACKAGE_TYPE_ISO || fileExt === GlobalConstants.PACKAGE_TYPE_DEB) {
      this.pkgTypeForGA = fileExt;
      this.osForGA = GlobalConstants.LINUX;
    } else {
      this.dataToGA(profile);
    }
    this.checkCustomMainTileAdded(profile.profileId);
    if(isGamingIncluded){
      this.profileService.isCurrentGamingPackageSelectedForDownload = true;
      this.createProfileService.getPubProfile(profile.profileId).subscribe((x)=>{
        this.currentProfileGameName = JSON.parse(x.profile.settings)?.otherSettings?.available_game;
      });
    }
    else{
      this.profileService.isCurrentGamingPackageSelectedForDownload = false;
    }
  }

  openDelete(profileDetails) {
    const modalRef = this.modalService.open(DeleteComponent);
    modalRef.componentInstance.profileDetails = profileDetails;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.getAllProfilesByUserId();
      this.modalService.dismissAll();
    })
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDuplicate(profileName: string, profileId: string) {
    this.currentProfileName = profileName;
    this.currentProfileId = profileId;
    this.openModal(this.duplicateProfile);
  }

  createDuplicateProfile(newProfileName: string) {
    this.profileService.createDuplicateProfile(this.currentProfileId, newProfileName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllProfileContentResponse => {
        this.getAllProfilesByUserId();
      });
  }

  confirmGenerateProfile() {
    this.choosePackage(this.selectedProfile, this.selProfileIndex);
    this.closeModal(this.confirmGenModal);
  }

  onTableDataChange(event) {
    this.page = event;
    this.getAllProfilesByUserId();
  }

  showCreateProfile() {
    this.router.navigate([RouterConstants.CREATE_PROFILE_LINK]);
  }

  checkifCreator(profile): boolean { 
    const contentTypeArr = profile?.contentTypes[0].split(",").map(s => s.replace(/(^"|"$)/g, ""));
    return contentTypeArr.includes('Creator') && contentTypeArr.length === 1;
  }

  editProfile(id: string,data?) {
    if (!this.checkProfileLite(data)) {
      return;
    }
    this.router.navigate([RouterConstants.EDIT_PROFILE, id]);
  }

  closePopup() {
    this.downloadPopup = false;
  }

  copyPackageURL(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

  downloadPackage() {
    //As part of Profile response cleanup - Commenting the below Code on GA.
    //TODO: Need to connect with GA Team.
    //this.sendToGA(); 
    if(this.profileService.isCurrentGamingPackageSelectedForDownload){
      this.googleAnalyticsService.gameIncludedToThePackage(this.currentProfileGameName,this.profileId,this.profileName)
    }
    this.commonService.downloadPackage(this.downloadUrl, this.fullPkgName, this.fileExtension);    
  }

  navigateToStandardIPOS() {
    this.router.navigate([GlobalConstants.SLASH + GlobalConstants.STANDARD_DOWNLAOD]);
  }

  // function to check If main tile asset content group added in selected profile or not
  checkCustomMainTileAdded(profileId) {
    this.createProfileService.getProfileDetailsById(profileId)
      .subscribe(profileDetailsresponse => {
        if (JSON.parse(profileDetailsresponse?.profile?.retailerConfiguartion)?.customSrtEnabled) {
          if (profileDetailsresponse?.profile?.customHeroTiles?.length) {
            this.customMainTileAdded = true;
          }
        }
      });
  }

  checkPackageType(profile: any) {  //check all Windows Packages Standard/Gaming/Creator
    let packagedTypes = this.removeStringifiedArray(profile?.contentTypes);
    if (packagedTypes?.length > 0) {
      if (packagedTypes?.length == 1) {
        this.pkgTypeForGA = packagedTypes[0];
      }
      else {
        let pkgTypes = '';
        for (let i = 0; i < packagedTypes?.length; i++) {
          if (i === packagedTypes?.length - 1) {
            pkgTypes += packagedTypes[i];
          } else {
            pkgTypes += packagedTypes[i] + ' - ';
          }
        }
        this.pkgTypeForGA = pkgTypes;
      }
    }
  }

  dataToGA(profile: any) {
    if (profile.operatingSystem === GlobalConstants.WINDOWS_10S || profile.operatingSystem === GlobalConstants.WINDOWSUWP) {
      this.pkgTypeForGA = GlobalConstants.UWP;
      this.osForGA = GlobalConstants.WINDOWSUWP;
    }
    else if (profile.operatingSystem === GlobalConstants.CHROME_TEXT) {
      this.pkgTypeForGA = GlobalConstants.CHROME;
      this.osForGA = GlobalConstants.CHROME_TEXT;
    }
    else {
      this.pkgTypeForGA = GlobalConstants.PACKAGE_TYPE_WIN;
      this.osForGA = GlobalConstants.WINDOWS;
      this.checkPackageType(profile);
    }
  }

  sendToGA() {
    const idleDisplay = JSON.parse(this.profileSettingsForGA)?.idleExperience?.IdleDisplay;
    const increasedPromoRotation = JSON.parse(this.profileSettingsForGA)?.otherSettings?.increasePromotionRotation;
    this.googleAnalyticsService.idleExperienceOption(idleDisplay);
    if (increasedPromoRotation) {
      this.googleAnalyticsService.increasedPromoRotation();
    }
    if (JSON.parse(this.profileSettingsForGA)?.otherSettings?.skuList?.length) {
      this.googleAnalyticsService.SkuContentAddedInPackage();
    }
    if (JSON.parse(this.profileSettingsForGA)?.idleExperience?.isStandard4kVideoIncluded) {
      this.googleAnalyticsService.is4kVideoEnabled();
    }
    if (!JSON.parse(this.profileSettingsForGA)?.otherSettings?.isExcludeGameDemo) {
      var gameName = JSON.parse(this.profileSettingsForGA)?.otherSettings?.available_game;
      if (gameName?.includes(GlobalConstants.THREE_KINGDOMS_VALUE)) {
        gameName = GlobalConstants.MONSTER_HUNTER_SUNBREAK_VALUE;
      }
      // this.googleAnalyticsService.gameIncludedToThePackage(gameName,this.profileId,this.profileName);
    }
    if (this.customMainTileAdded) {
      this.googleAnalyticsService.customMainTileContentGroupAdded();
    }
    let pkgInfoForGA = this.osForGA + ' | ' + this.pkgTypeForGA + ' | ' + this.pkgLangForGA + ' | ' + GlobalConstants.CUSTOM_PKG;
    this.googleAnalyticsService.downloadPackageTracking(pkgInfoForGA);
  }
  onFilter(selectedValue: string) {
    this.page = 1;
    this.count = 0;
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.selectedValue = selectedValue;
    this.profileData = [];
    if (this.isProfileSearch) {
      this.searchProfilesReport(this.searchData);
    }
    this.getReportFilterSearchData();
  }
  viewDevices(profileData) {
    let tempJson = {
      profileId: (this.selectedValue == 'standard') ? profileData?.sortKey : profileData.profileId,
      profileName: profileData.profileName,
      retailerID: this.retailerID,
      packageSize: profileData.packageSize,
      packageStatus: profileData.packageStatus,
      standardType: (this.selectedValue == 'standard') ? true : false,
      allowNonIntel: (this.selectedValue == 'standard') ? undefined : profileData?.allowNonIntel
    }
    this.commonService.emitViewDevices(tempJson);
  }

  sort(tempval: string) {
    this.isTableSortApplied = true;
    let sortOrder = OemConstants.EMPTY_VALUE;
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? OemConstants.ASCENDING_ORDER :
      OemConstants.DESCENDING_ORDER;
    this.sortBy = tempval;
    this.sortType = sortOrder;
    this.getAllProfilesByUserId();
  }

  onProfileSearchInput(val: string) {
    if (val?.length === 0) {
      this.clearProfileSearch();
    }
  }

  clearProfileSearch() {
    this.profileSearchBy = '';
    this.searchQueue = {};
    this.getReportFilterSearchData();
    this.searchData = ActiveUserConstants.EMPTY_VALUE;
    this.animateThis.nativeElement.value = '';
    this.searchData = '';
    this.page = 1;
    this.isProfileSearch = false;
  }

  getReportFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.searchQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
    }
    this.getAllProfilesByUserId();
  }

  searchProfilesReport(searchData) {
    this.isProfileSearch = true;
    this.searchClose = true;
    if (this.selectedValue == 'custom') {
      if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
        this.searchTag = DevicesConstants.PROFILE_SEARCH_BY;
        this.loadFlag = StoresConstant.UNLOAD_FLAG;
      }
      if (searchData && this.searchTag) {
        this.searchQueue = {};// To clear previous Profile search seletion
        this.searchQueue[this.searchTag] = encodeURIComponent(searchData);
        this.getReportFilterSearchData();
      } else {
        this.getAllProfilesByUserId();
        this.page = 1;
      }
    } else {
      this.getReportFilterSearchData();
    }
  }

  searchReportOnEnter(searchData) {
    this.isProfileSearch = true;
    this.animateThis.nativeElement.blur();
    this.searchProfilesReport(searchData);
  }
  //IIT2-17363
  sendDataToGA(profileId) {
    this.createProfileService.getProfileDetailsById(profileId)
      .subscribe(profileData => {
        let tempSettings = JSON.parse(profileData.profile?.settings);
        let dataObj = {
          profile_id: this.profileId,
          profile_name: profileData.profile?.profileName,
          os_type: tempSettings?.otherSettings?.operatingSystem,
          package_type: tempSettings?.otherSettings?.contentTypes?.packagedTypes,
          package_status_idle_experience: tempSettings?.otherSettings?.increasePromotionRotation ? 'increase_Promotion_Rotation' : tempSettings?.idleExperience?.IdleDisplay,
        }
        if (dataObj.package_status_idle_experience == 'Fact Tag Rotation') {
          let val =
            tempSettings?.idleExperience?.isLogoContentEnabled && tempSettings?.idleExperience?.isSegmentContentEnabled ? 'Included_Logo_Content_Groups_nd_Include_Segment_Content_Groups' :
              tempSettings?.idleExperience?.isLogoContentEnabled ? 'Included_Logo_Content_Groups' :
                tempSettings?.idleExperience?.isSegmentContentEnabled ? 'Included_Segment_Content_Groups' : 'unset'
          dataObj['package_status_Idle_fact_tag_rotation'] = val;
        } else if (dataObj.package_status_idle_experience == 'AttractLoop') {
          let attarctVal = tempSettings?.idleExperience?.isStandard4kVideoIncluded && profileData.profile?.attractLoop ? 'is4kVideoselected_nd_Retailer_Attractloop' :
            tempSettings?.idleExperience?.isStandard4kVideoIncluded ? 'is4kVideoselected' :
              profileData.profile?.attractLoop ? 'Retailer_Attractloop' : 'unset'
          dataObj['package_status_attract_loop_enabled'] = attarctVal;
        }
        this.googleAnalyticsService.packageIdleExperienceInformation(dataObj);
      });
  }

  checkProfileLite(data) {
    if (data?.operatingSystem === 'IPOSLITE' && !this.enableIposlite) {
      return false;
    }
    else {
      return true;
    }
  }
}

